<template>
  <a-modal :title="title" :visible="visible" @ok="ok" @cancel="cancel" okText='确定' cancelText='取消' destroyOnClose
    :maskClosable="false" width="800px">
    <a-row type="flex" justify="space-between" align="middle" style="margin-bottom:10px">
      <div>
        <a-input @change='filterList' v-model="searchKey" placeholder="原料名称/代码">
          <a-icon slot="suffix" type="search" @click="filterList" />
        </a-input>
      </div>
      <div>
        <type-list v-model="typeId" category="raw" @setVal='setVal' placeholder="选择原料类型" />
      </div>
    </a-row>
    <a-table ref="listRef" :columns="columns" :data-source="list" :pagination="false" :scroll="{ y }"
      :row-selection="rowSelection" row-key="id">
      <template slot="rawTypeName" slot-scope="text, record, index">
        <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
          <template slot="title">
            {{ record.fullTypeName }}
          </template>
          <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
        </a-tooltip>
      </template>
      <div slot="status" slot-scope="text, record">
        <span :style="{ color: !text ? 'green' : 'red' }">{{
          !text ? "激活" : "失效"
        }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import TypeList from '@/components/Common/components/Type.vue';
export default {
  components: { TypeList },
  props: ['visible', 'addIds', 'formulaIdList'],
  data() {
    return {
      allMaterialVisible: false,
      title: <p>导入原料</p>,
      list: [],
      y: 300,
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize });
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList({ current: 1, pageSize });
        } //每页多少条
      },
      columns: [
        {
          title: '原料名称',
          dataIndex: 'name',
          width: 100,
          ellipsis: true,
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 100,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "rawTypeName" },
        },
        {
          title: '状态/类目归属',
          dataIndex: 'status',
          width: 120,
          scopedSlots: { customRender: 'status' }
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unit',
        //   width: 100,
        //   ellipsis: true,
        // }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      cacheData: [],
      searchKey: '',
      typeId: undefined
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.searchKey = '';
        this.typeId = undefined;
        this.selectedRowKeys = [];
        this.selectedRows = [];
        this.getList();
      } else {
        this.pagination.total = 0;
        this.pagination.pageSize = 20;
        this.pagination.current = 1;
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
        selectedRowKeys: this.selectedRowKeys
      };
    },
  },
  methods: {
    ok() {
      // let list = this.selectedRows.map(el => {
      //   let {code,name,rawId} = el || {}
      //   return {code,name,rawId,minValue: '',maxValue: ''}
      // })
      let formulaRawList = this.selectedRowKeys.map(rawId => {
        return { rawId };
      });
      let data = {
        formulaIdList: this.formulaIdList, formulaRawList
      };
      this.$http.post('/nhf-app/formulaManage/addFormulaRawToUpdate', data).then(res => {
        let { success, data, msg } = res || {};
        let feild = 'warning';
        if (success) {
          feild = 'success';
          data && data.map(el => {
            if (el.maxValue === null) el.maxValue = '';
            if (el.minValue === null) el.minValue = '';
            return el;
          });
          setTimeout(() => {
            this.$emit('close', data);
          }, 0);
        }
        this.$message[feild](msg);
      });

    },
    cancel() {
      this.$emit('close', false);
    },
    itemUpdate() { },
    update() { },
    getList() {
      // let {pageSize,current} = pagination || this.pagination
      // let factoryId = window.localStorage.getItem('factoryId')
      // let staffId = window.localStorage.getItem('staffId')
      let params = {
        // query: {current,size: pageSize},
        formulaIdList: this.formulaIdList,
        factoryId: window.localStorage.getItem('factoryId'),
        // rawIdList: this.addIds,
        // staffId,factoryId
      };
      this.$http.post('/nhf-app/formulaManage/selectFormulaRaws', params).then(res => {
        let { success, data } = res;
        if (success) {
          // let {records,current=1,total=0} = data;
          // this.pagination.current = current
          // this.pagination.total = total
          this.list = data || [];
          this.cacheData = JSON.parse(JSON.stringify(data || []));
        }
      });
    },

    filterList() {
      let list = JSON.parse(JSON.stringify(this.cacheData));
      if (this.searchKey) {
        list = list.filter(e => e.code.indexOf(this.searchKey) >= 0 || e.name.indexOf(this.searchKey) >= 0);
      }
      if (this.typeId) {
        list = list.filter(e => e.typeId === this.typeId);
      }
      this.list = list || [];
    },
    setVal(val) {
      if (val) {
        this.typeId = val ? val[val.length - 1] : undefined;
      } else {
        this.typeId = undefined;
      }
      this.filterList();
    },
    rawTypeNameTipsVisibleChange(show, item) {
      item.color = show ? '#1677FF' : '';
      this.$forceUpdate();
    },
  }
};
</script>
